"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.useInitialValues = void 0;
var react_1 = require("react");
var swr_hooks_1 = require("@l2p/swr-hooks");
var swr_hooks_2 = require("@l2p/swr-hooks");
var useInitialValues = function () {
    var _a;
    var data = (0, swr_hooks_1.useGeo)().data;
    var countries = (0, swr_hooks_2.useCountriesOptions)();
    var currencies = (0, swr_hooks_1.useGenerateCurrencies)();
    var currentCurrency = (0, swr_hooks_1.useCurrentCurrency)();
    var currentCountry = (0, react_1.useMemo)(function () {
        return countries.find(function (country) { var _a; return country.value === ((_a = data === null || data === void 0 ? void 0 : data.geoData) === null || _a === void 0 ? void 0 : _a.countryCode); });
    }, [countries, (_a = data === null || data === void 0 ? void 0 : data.geoData) === null || _a === void 0 ? void 0 : _a.countryCode]);
    return (0, react_1.useMemo)(function () { return ({
        country: currentCountry,
        currency: (currencies === null || currencies === void 0 ? void 0 : currencies.find(function (currency) { return currency.value === currentCurrency; })) ||
            (currencies === null || currencies === void 0 ? void 0 : currencies[0]),
        acceptTerms: false,
    }); }, [currentCountry, currencies, currentCurrency]);
};
exports.useInitialValues = useInitialValues;
